import Store from 'lightningjs-redux';
import { getPlayerInstance } from '@bedrock-rdk/media-engine';
import { defaultService, video as videoSettings } from '@bedrock-rdk/config';
import { fetchUpfrontToken } from '../../logic/player/player.actions';
import { setAttributes } from '../../logic/analytics/analytics.utils';
import { audioPreferenceToManifestTrack, textPreferenceToManifestTrack } from '../../logic/player/player.utils';
import { PlaybackController } from './playback.controller';
import { createRenderers, enhancePlayerConfig } from './player.utils';
import { playerDispatcher } from './player.dispatcher';

/**
 * @returns {PlaybackController} controller of the main content engine
 */
export const createContentPlayback = () =>
  new PlaybackController({
    loadEngine: () => getPlayerInstance().then(({ Engine }) => Engine),
    createSurface: () => {
      const { video, container, subtitles } = createRenderers('main-player');

      return { element: video, container, subtitles };
    },
    getOptions: async (params, { subtitles }, Engine) => {
      const { audioTrack, textTrack } = Store.getState().player.preferences || {};

      setAttributes({
        playerName: Engine.PLAYER_NAME,
        playerVersion: Engine.PLAYER_VERSION,
      });

      // NOTE: the config could depend on a device model, which resolution could be async for some platforms
      return enhancePlayerConfig({
        dispatcher: playerDispatcher,
        drm: {
          settings: videoSettings.drm,
          token: {
            handler: () => Store.dispatch(fetchUpfrontToken(defaultService)),
          },
        },
        subtitlesContainer: subtitles,
        userPreferences: {
          audio: audioPreferenceToManifestTrack(audioTrack),
          text: textPreferenceToManifestTrack(textTrack),
        },
      });
    },
  });
